import { type JSX } from 'react';
import { type LucideIcon } from 'lucide-react';
import {
  SidebarNavSection,
  type SidebarNavSectionItem,
} from './SidebarNavSection';

interface ShadowAINavGroupProps {
  /** Route the group's parent + "Tools" child navigate to (the shadow-ai root). */
  to: string;
  /** Icon for the parent row (Bot on org, Ghost on the personal dashboard). */
  icon: LucideIcon;
  /**
   * Whether to render the "Network Discovery" child. The org view passes the
   * SHADOW_AI_NETWORK_DISCOVERY flag; the personal dashboard has no Network
   * Discovery page and always passes `false`.
   */
  showNetworkDiscovery: boolean;
}

/**
 * ShadowAINavGroup — the "Shadow AI" sidebar section.
 *
 * Child sub-pages via {@link SidebarNavSection}: "Tools" (the shadow-ai root)
 * and — when `showNetworkDiscovery` is set — "Network Discovery"
 * (`/shadow-ai/network-discovery`).
 */
export function ShadowAINavGroup({
  to,
  icon,
  showNetworkDiscovery,
}: ShadowAINavGroupProps): JSX.Element {
  const items: SidebarNavSectionItem[] = [
    { label: 'Tools', to },
    ...(showNetworkDiscovery
      ? [{ label: 'Network Discovery', to: `${to}/network-discovery` }]
      : []),
  ];

  return (
    <SidebarNavSection label="Shadow AI" to={to} icon={icon} items={items} />
  );
}
